var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-table-collection',{attrs:{"view":"re-details?for=Group&id=${Id}","label":_vm.label,"path":"group","object":"Group","filter":_vm.filter,"detail-view":"Product","main-view":true,"state-view":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }